
import {Component, Prop} from 'nuxt-property-decorator';
import BaseFormComponent from '~/components/Form/BaseFormComponent';
import {ALLOWED_FILE_TYPES, FileType, fileTypeToMimeType, MimeType} from '~/etc/mimetypes';
import {AVAILABLE_EDIT_MODES, EditMode} from '~/lib/types/EditMode';
import {castToHtmlElement} from '~/lib/util/util';


@Component({
})
export default class FormAvatarPicker extends BaseFormComponent {
  @Prop({
    type: String,
    required: true,
  })
  label!: string

  @Prop({
    type: String,
    required: false,
  })
  name!: string

  @Prop({
    type: Boolean,
    default: false,
  })
  required!: boolean

  @Prop({
    type: String,
    required: true,
    validator(value: FileType): boolean {
      return ALLOWED_FILE_TYPES.includes(value);
    }
  })
  fileType!: FileType

  @Prop({
    type: String,
    default: null,
  })
  mode!: null | 'small-edit' | 'standard' | 'label-hidden-autosave'

  @Prop({
    type: String,
    default: null,
    validator(value: EditMode): boolean {
      return AVAILABLE_EDIT_MODES.includes(value);
    }
  })
  editMode!: EditMode

  @Prop({
    type: File,
    default: null,
  })
  file!: File

  @Prop({
    type: String,
    default: null,
  })
  imgSrc!: string

  @Prop({
    type: Boolean,
    default: false,
  })
  withPhotoCropper!: boolean

  fileUrl: string | null = this.imgSrc

  get mime(): MimeType {
    return fileTypeToMimeType[this.fileType];
  }

  get accept(): string {
    return this.mime.accept();
  }

  mounted() {
    this.$on('clear', () => {
      this.clearInput();
    });
  }

  selectFile(event: Event) {
    const files = (event.target as HTMLInputElement)!.files!;

    console.log('files', files);

    if (!this.doValidate(!!files, 'Nie wybrano pliku')) return this.clearInput();
    if (files.length === 0) return this.clearInput();
    if (!this.doValidate(files.length === 1, 'Należy wybrać tylko jeden plik')) return this.clearInput();
    if (!this.doValidate(this.mime.contentTypes.includes(files[0].type),
        `Błędne rozszerzenie pliku. Obsługiwane rozszerzenia to: ${this.mime.fileExtensions.join(', ')}`)) return this.clearInput();

    if (!this.fileUrl && this.$refs.img && this.$refs.svg) {
      (this.$refs.img as HTMLElement).style.width = `${(this.$refs.svg as HTMLElement).clientWidth}px`;
    }

    const file: File = files[0];
    const fileUrl = URL.createObjectURL(file);

    // default behaviour
    if(! this.withPhotoCropper) {
      this.fileUrl = fileUrl

      this.$emit('input', file);
    } else {
      // @ts-ignore
      this.$refs.photoCropper!.$emit('open', fileUrl);

      this.$once('croppedBlob', (croppedPhoto: CropperPhotoEvent) => {
        const file = new File([croppedPhoto.blob], 'child_photo.png', {type: croppedPhoto.blob.type});
        const fileUrl = URL.createObjectURL(file);

        // @ts-ignore
        this.$refs.photoCropper!.$emit('close');

        this.fileUrl = fileUrl;
        this.$emit('input', file);
      });
    }

  }

  clearInput() {
    const input: HTMLInputElement = castToHtmlElement<HTMLInputElement>(this.$refs.inputFile as any)!;
    input.value = '';
    this.fileUrl = null;
  }
}
